module.exports = __webpack_public_path__ + "img/wallet.2b721a5d.svg";